"use client";

import { Boilerplate } from "@prisma/client";
import { ExternalLink } from "lucide-react";
import Link from "next/link";

import { track } from "@vercel/analytics/react";
import { Button } from "../ui/button";
import { addClickRowToTinyBird } from "./action";

export default function VisitSiteButton({
  boilerplate,
}: {
  boilerplate: Boilerplate
}) {
  return (
    <Link
      onClick={() => {
        addClickRowToTinyBird({ pathname: `/boilerplates/${boilerplate.id}` })
        track("click_visit_site_button", {
          boilerplateId: boilerplate.id,
        })
      }}
      target="_blank"
      href={
        boilerplate.affiliateLink ? boilerplate.affiliateLink : boilerplate.link
      }
    >
      <Button className="flex items-center gap-4">
        <ExternalLink />
        <span>Visit site</span>
      </Button>
    </Link>
  )
}
